module.exports = __webpack_public_path__ + "img/twitter-icon-dark.cbcd527e.svg";